import { useCallback } from 'react'

const EMOJIS = ['🌸', '🌺', '🌼', '✨', '🎉', '🌷', '💫', '🎊']
const COLORS = ['#7B6FD0', '#2dd4bf', '#fb923c', '#f472b6', '#34d399', '#fbbf24']

function createParticle(x, y) {
  const el = document.createElement('div')

  const useEmoji = Math.random() > 0.4
  const size     = 12 + Math.random() * 16

  el.style.cssText = `
    position: fixed;
    left: ${x}px;
    top: ${y}px;
    pointer-events: none;
    z-index: 9999;
    font-size: ${size}px;
    user-select: none;
    will-change: transform, opacity;
  `

  if (useEmoji) {
    el.textContent = EMOJIS[Math.floor(Math.random() * EMOJIS.length)]
  } else {
    el.style.width    = `${size * 0.6}px`
    el.style.height   = `${size * 0.6}px`
    el.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px'
    el.style.background = COLORS[Math.floor(Math.random() * COLORS.length)]
  }

  document.body.appendChild(el)

  const angle    = (Math.random() * 360) * (Math.PI / 180)
  const velocity = 80 + Math.random() * 160
  const vx       = Math.cos(angle) * velocity
  const vy       = Math.sin(angle) * velocity - 120 // boost vers le haut
  const rotation = (Math.random() - 0.5) * 720
  const duration = 800 + Math.random() * 600

  let start = null

  const animate = (timestamp) => {
    if (!start) start = timestamp
    const elapsed = timestamp - start
    const progress = elapsed / duration

    if (progress >= 1) {
      el.remove()
      return
    }

    const easeOut = 1 - Math.pow(progress, 2)
    const gravity = progress * progress * 200

    const currentX = x + vx * progress
    const currentY = y + vy * progress + gravity
    const opacity  = progress < 0.7 ? 1 : (1 - progress) / 0.3
    const scale    = easeOut * (0.6 + Math.random() * 0.4)

    el.style.transform = `translate(${currentX - x}px, ${currentY - y}px) rotate(${rotation * progress}deg) scale(${scale})`
    el.style.opacity   = opacity

    requestAnimationFrame(animate)
  }

  requestAnimationFrame(animate)
}

export function useConfetti() {
  const fire = useCallback((originEl = null) => {
    // Trouver le point d'origine
    let x = window.innerWidth  / 2
    let y = window.innerHeight / 2

    if (originEl) {
      const rect = originEl.getBoundingClientRect()
      x = rect.left + rect.width  / 2
      y = rect.top  + rect.height / 2
    }

    // Lancer les particules en vagues
    const total = 80

    for (let i = 0; i < total; i++) {
      setTimeout(() => createParticle(x, y), i * 18)
    }

    // Deuxième vague depuis le haut de l'écran
    setTimeout(() => {
      for (let i = 0; i < 40; i++) {
        setTimeout(() => {
          createParticle(
            Math.random() * window.innerWidth,
            -10
          )
        }, i * 30)
      }
    }, 200)
  }, [])

  return fire
}